export const timeZonesSelectOptions = [
  {
    id: '1',
    label: 'America/Los_Angeles (Pacific Time - Los Angeles)'
  },
  {
    id: '2',
    label: 'America/Chicago (Central Time - Chicago)'
  },
  {
    id: '3',
    label: 'America/New_York (Eastern Time - New York)'
  },
  {
    id: '4',
    label: 'America/Salt_Lake_City (Mountain Time - Salt Lake City)'
  },
  {
    id: '5',
    label: 'America/Phoenix (Mountain Time - Phoenix)'
  },
  {
    id: '6',
    label: 'America/Anchorage (Alaska Time - Anchorage)'
  },
  {
    id: '7',
    label: 'Pacific/Honolulu (Hawaii Time - Honolulu)'
  },
  {
    id: '8',
    label: 'America/Adak (Hawaii Time - Adak)'
  }
]

export const statesSelectOptions = [
  { id: 'AL', label: 'Alabama' },
  { id: 'AK', label: 'Alaska' },
  { id: 'AZ', label: 'Arizona' },
  { id: 'AR', label: 'Arkansas' },
  { id: 'CA', label: 'California' },
  {
    id: 'CO',
    label: 'Colorado'
  },
  { id: 'CT', label: 'Connecticut' },
  { id: 'DE', label: 'Delaware' },
  { id: 'FL', label: 'Florida' },
  { id: 'GA', label: 'Georgia' },
  { id: 'HI', label: 'Hawaii' },
  { id: 'ID', label: 'Idaho' },
  { id: 'IL', label: 'Illinois' },
  { id: 'IN', label: 'Indiana' },
  { id: 'IA', label: 'Iowa' },
  { id: 'KS', label: 'Kansas' },
  { id: 'KY', label: 'Kentucky' },
  { id: 'LA', label: 'Louisiana' },
  { id: 'ME', label: 'Maine' },
  { id: 'MD', label: 'Maryland' },
  { id: 'MA', label: 'Massachusetts' },
  { id: 'MI', label: 'Michigan' },
  { id: 'MN', label: 'Minnesota' },
  { id: 'MS', label: 'Mississippi' },
  { id: 'MO', label: 'Missouri' },
  { id: 'MT', label: 'Montana' },
  { id: 'NE', label: 'Nebraska' },
  { id: 'NV', label: 'Nevada' },
  { id: 'NH', label: 'New Hampshire' },
  { id: 'NJ', label: 'New Jersey' },
  { id: 'NM', label: 'New Mexico' },
  { id: 'NY', label: 'New York' },
  { id: 'NC', label: 'North Carolina' },
  { id: 'ND', label: 'North Dakota' },
  { id: 'OH', label: 'Ohio' },
  { id: 'OK', label: 'Oklahoma' },
  { id: 'OR', label: 'Oregon' },
  { id: 'PA', label: 'Pennsylvania' },
  { id: 'RI', label: 'Rhode Island' },
  { id: 'SC', label: 'South Carolina' },
  { id: 'SD', label: 'South Dakota' },
  { id: 'TN', label: 'Tennessee' },
  { id: 'TX', label: 'Texas' },
  { id: 'UT', label: 'Utah' },
  { id: 'VT', label: 'Vermont' },
  { id: 'VA', label: 'Virginia' },
  { id: 'WA', label: 'Washington' },
  { id: 'WV', label: 'West Virginia' },
  { id: 'WI', label: 'Wisconsin' },
  { id: 'WY', label: 'Wyoming' }
]

export const calendarHeaderToolbar = {
  left: 'prev,next,today',
  center: 'title',
  right: ''
}

export const calendarWeeklyHeaderToolbar = {
  left: 'prev,next,today',
  center: 'title',
  right: 'orderView,truckView'
}

export const calendarTimeAllocationHeaderToolbar = {
  left: 'prev,next,today',
  center: 'title',
  right: ''
}

export const TAB_MONTHLY = 0
export const TAB_WEEKLY = 1
export const TAB_DAILY = 2
export const TAB_SETTINGS = 3
export const TAB_TIME_ALLOCATION = 4
